<!-- <div style="padding: 20px;">
<mr-ngx-plaid-link-button
  env="sandbox"
  [clientName]="'CapEd Banking App'"
  [product]="['transactions', 'auth']"
  [countryCodes]="['US']"
  (Success)="onPlaidSuccess($event)"
  (Exit)="onPlaidExit($event)"
  buttonText="Connect Bank Account"
></mr-ngx-plaid-link-button>
<div *ngIf="transactions.length">
  <h2>Transactions</h2>
  <ul>
    <li *ngFor="let tx of transactions">
      {{ tx.date }} - {{ tx.name }}: ${{ tx.amount }}
    </li>
  </ul>
</div>
</div> -->
<div>
  <h2>Transactions</h2>
  <button (click)="initializePlaidLink()">Connect a Bank Account</button>
  <ul>
    @for (tx of transactions; track tx) {
      <li>
        {{ tx.date }} - {{ tx.name }}: ${{ tx.amount }}
      </li>
    }
  </ul>
</div>